import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import * as PIXI from "pixi.js";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractBigWinProperties.ts
 */
export class AbstractBigWinProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.animationProperties.equals(other.animationProperties) &&
            this.counterProperties.equals(other.counterProperties) &&
            this.size.equals(other.size) &&
            this.mouseBlockerProperties.equals(other.mouseBlockerProperties) &&
            this.counterDuration === other.counterDuration &&
            this.showCounter === other.showCounter;
    }
    setDefaultValues() {
        this.mouseBlockerProperties = new MouseBlockerProperties(0x000000, 0.6);
        this.animationProperties = new SpineProperties(SlingoStyle.BIG_WIN_ANIMATION, SlingoStyle.MODULE, new PIXI.Point(973, 512), new PIXI.Point(0.5, 0.5));
        this.counterProperties = new TextFieldProperties(FontStyle.BIG_WIN_ANIMATION_COUNTER, new PIXI.Point(0, 80), null, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(560, 200));
        this.size = new PIXI.Point(2436, 1280);
        this.counterDuration = 6;
        this.showCounter = false;
    }
}
//# sourceMappingURL=AbstractBigWinProperties.js.map